var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.401,
    height: 17.522,
    viewBox: "0 0 15.401 17.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41526",
    "data-name": "Group 41526",
    transform: "translate(-2.65 -1.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.616,0H12.285A1.621,1.621,0,0,1,13.9,1.616V3.394a3.017,3.017,0,0,1-.808,1.859L9.618,8.325a2.631,2.631,0,0,0-.808,1.859v3.475a1.8,1.8,0,0,1-.727,1.374l-1.131.727a1.647,1.647,0,0,1-2.505-1.374V10.1a3.124,3.124,0,0,0-.647-1.7L.727,5.173A2.679,2.679,0,0,1,0,3.556V1.7A1.64,1.64,0,0,1,1.616,0Z",
    transform: "translate(3.4 2.1)",
    fill: "none",
    stroke: "#c1cbde",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1222",
    "data-name": "Line 1222",
    x1: 5.657,
    transform: "translate(10.755 6.464)",
    fill: "none",
    stroke: "#c1cbde",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFilter);
export default __webpack_public_path__ + "static/media/icn_filter.06de84eb26ec79b1ce7ced1ea2fbef82.svg";
export { ForwardRef as ReactComponent };